import React, { useEffect, useState } from "react";
// import Sidebar from "../sidebar/Sidebar";
import Navbar from "../navbar/Navbar";
import "./Page.css";
import AuditDetails from "../auditdetails/AuditDetails";
import AuditRows from "../audits/AuditRows";
import { initilaDetailsObj } from "../../utils/Constants";
import {
  getAuditRows,
  getFilteredAuditData,
  // getPassedRecords,
  // getPassedRecordsDetails,
  getauditData,
  recall_episode,
  fetchUnassignedEpisodes
} from "../../api/Service";
import { Spinner } from "../../common/Helper";
import { useChatContext } from "../../../../../context";
import SidenavbarTemp from "../sidenavbar/SidenavbarTemp";

function Page({ isRowClicked, setIsRowClicked, mode, setMode }) {
  const { webWorkFlow } = useChatContext();
  const { auditDetails, setAuditDetails ,failedAudits,setFailedAudits} = webWorkFlow;
  const [isDetailsLoading, setIsDetailsLoading] = useState(false);
  const [auditRows, setAuditRows] = useState([]);
  const [flagauditRows, setflagAuditRows] = useState(false);
  const [isRowsLoading, setIsRowsLoading] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [searchEpisodeIdentifier, setSearchEpisodeIdentifier] = useState("");
  const [recommendations, setRecommendations] = useState([]);
  const [selectAllFiles, setSelectAllFiles] = useState(false);
  const [selectedEpisodeRows, setSelectedEpisodeRows] = useState([]);
  const [isAllEpisodesSelected, setIsAllEpisodesSelected] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);
  const [recall_page, setRecall_page] = useState(false);
  const [isAssigned,setIsAssigned] = useState(false);
  const [unassined_page,setUnassined_page] = useState(false)
  const [appliedFilters, setAppliedFilters] = useState({
    insurer_identifier: [],
    priority_value: [],
    episode_identifier: [],
    status: [],
    file_type: [],
    header_id: [],
    coder_name: [],
    admission_date_from: "",
    admission_date_to: "",
    separation_date_from: "",
    separation_date_to: "",
    length_of_stay: [],
    assigned_by: [],
    assigned_to: [],
    audit_ref_no: [],
    uploaded_by_user_name: [],
    hcp_line_updated_at: [],
    short_description: [],
    case_mix_speciality: [],
    drg:[],
    csv_selected_list:[],
    deselected_list: [],
  });
  const assginedUserId = JSON.parse(sessionStorage.getItem("userId"));
  const [addUnassignReason , setAddUnassignReason] = useState("");

  const [isP5Clicked, setIsP5Clicked] = useState(false);
  const [priorityVal5, setPriorityVal5] = useState(false);
  const [editFlageData, seteditFlageData] = useState();

  const [selectedColumns, setSelectedColumns] = useState([
    { id: "priority", label: "Priority", checked: false },
    { id: "file_name", label: "Document Name", checked: false },
    {id:"audit_ref_no",label:"Reference Id",checked:false},
    { id: "coded_by", label: "Coded By", checked: false },
    { id: "uploaded_by_user_name", label: "Uploaded By", checked: false },
    { id: "date", label: "Date", checked: false },
    { id: "assigned_by", label: "Assigned By", checked: false },
    { id: "assigned_to", label: "Assigned To", checked: false },
    {
      id: "audit_rule_short_description",
      label: "Description",
      checked: false,
    },
    { id: "status", label: "Status", checked: false },
    { id: "episode_identifier", label: "Episode Identifier", checked: false },
    { id: "hcp_line_updated_at", label: "Last Audited Date", checked: false },
  ]);
  //console.log(isP5Clicked, "isP5Clicked:::");
  const toggleColumnSelection = (columnId) => {
    setSelectedColumns((prevColumns) =>
      prevColumns.map((column) =>
        column.id === columnId
          ? { ...column, checked: !column.checked }
          : column
      )
    );
  };

  const shouldShowColumn = (columnId) => {
    const anyChecked = selectedColumns.some(col => col.checked);
    if (!anyChecked) return true; // Show all columns when none selected
    return selectedColumns.find(col => col.id === columnId)?.checked;
  };
  const getAuditDetailsById = async (hcp_line_id) => {
    //console.log('checkepiden',hcp_line_id);
    setIsDetailsLoading(true);
    // if (isP5Clicked) {
    //   return getPassedRecordsDetails(id)
    //     .then((data) => {
    //       const details = data.audited_rows[0];
    //       setAuditDetails({ ...details, id });
    //     })
    //     .catch((err) => {
    //      console.log(err.message);
    //       throw new Error(err.message);
    //     })
    //     .finally(() => {
    //       setIsDetailsLoading(false);
    //     });
    // }
    // return
    getauditData(hcp_line_id)
      .then((data) => {
        //console.log("DATA::::", data)
        const details = data.data.hcp_line_detail;
        setAuditDetails({ ...details, hcp_line_id });
        return { ...details, hcp_line_id };
      })
      .catch((err) => {
        // console.log(err.message);
        throw new Error(err.message);
      })
      .finally(() => {
        setIsDetailsLoading(false);
      });
  };
  const handleRowClick = (row) => {
    //console.log("ROW::::::", row)
    getAuditDetailsById(row.hcp_line_id);
    const index = auditRows.findIndex(
      (data) => data.hcp_line_id === row.hcp_line_id
    );
    setSelectedIndex(index);
    setIsRowClicked(true);
    // setIsAllEpisodesSelected(false);
    setSelectedEpisodeRows(selectedEpisodeRows);
    setPriorityVal5(row.priority_value === 5 ? true : false);
  };
  // const unflage=(row)=>{
  //   console.log("AUDITROW::::::", row);
  //   console.log('clciked')
  //   getAuditDetailsById(row.hcp_line_id);
  //   const index =  flagauditRows.findIndex((data) => data.hcp_line_id === row.hcp_line_id);
  //   setSelectedIndex(index);
  //   setIsRowClicked(true);
  //   setPriorityVal5(row.priority_value===5?true:false);
  // }
  //console.log('sdf',flagauditRows);
  const updatedAuditRows = (rows) => {
    setAuditRows(rows.reverse());
  };
  const getAuditRowsByFilter = async (filters) => {
    try {
      updatedAuditRows([]);
      setIsRowsLoading(true);
      setAuditDetails({});
      setAppliedFilters({ ...appliedFilters, ...filters });
      setHasMore(true);
      setIsP5Clicked(false);
      const appliedfilter = { ...appliedFilters, ...filters, pageNumber: 1 };
      const data = await getFilteredAuditData(appliedfilter);
      //console.log('jadgshjash',data);
      if (data.length) {
        setHasMore(true);
      }
      updatedAuditRows(data);
      setIsRowsLoading(false);
    } catch (err) {
      setIsRowsLoading(false);
      setHasMore(false);
    }
  };
  const handleRefreshClick = () => {
    setAuditDetails({});
    getAuditRowsData({});
    window.location.reload();
  };
  const getAuditRowsData = ({page = 1, status,isCameFromDetails}) => {
    setIsRowsLoading(true);
    if (status) {
      setflagAuditRows(true);
    }
    //console.log('checkstatus',flagauditRows,status);
    // const fetchRows = flagauditRows
    //   ? recall_episode({ page_number: page })
    //   : getAuditRows(page, appliedFilters);
  let fetchRows;

    if (isAssigned) {
      fetchRows = fetchUnassignedEpisodes( assginedUserId, appliedFilters, !recall_page,appliedFilters.header_id,page);
    } else if (flagauditRows) {
      fetchRows = recall_episode({ page_number: page });
    } else {
      fetchRows = getAuditRows(page, appliedFilters);
    }
    fetchRows
      .then((data) => {
        let newRows;

        if (unassined_page) {
          
          newRows = data?.unassigned_episodes
        } else if (flagauditRows) {
          newRows = data?.data?.data?.audited_rows;
        } else {
          newRows = data;
        }
        
        if (newRows.length === 0) {
          setHasMore(false);
        }
        if(isCameFromDetails){
          setAuditRows(()=>[...newRows])
        }
        else{
          setAuditRows((prevRows) => [...prevRows, ...newRows]);
        }
        
        setPage(page + 1);
      })
      .catch((err) => {
        //console.error("Error fetching audit rows:", err);
        setIsRowsLoading(false);
        setHasMore(false);
      })
      .finally(() => {
        setIsRowsLoading(false);
      });
  };

  const handlePreviousClick = () => {
    const index = selectedIndex - 1;
    getAuditDetailsById(
      auditRows[index].hcp_line_id,
      auditRows[index].priority_value
    );
    setSelectedIndex(index);
  };
  const handleNextClick = () => {
    const index = selectedIndex + 1;
    getAuditDetailsById(
      auditRows[index].hcp_line_id,
      auditRows[index].priority_value
    );
    setSelectedIndex(index);
  };
  const handleAuditDataUpdate = (hcp_line_id, status) => {
    getAuditDetailsById(hcp_line_id).then(() => {
      //getting
      const updatedRow = auditRows[selectedIndex];
      // updating
      updatedRow.hcp_line_id = hcp_line_id;
      updatedRow.status = status;
      //replacing in the same index
      auditRows[selectedIndex] = updatedRow;
    });
  };
useEffect(()=>{
    if(!isRowClicked){
  getAuditRowsData({isCameFromDetails:true})
 }
},[isRowClicked])
  useEffect(() => {
    getAuditRowsData({});
    window.scrollTo(0, 0);
  }, []);
  // useEffect(()=>{
  //   sessionStorage.setItem("flagStatus",flagauditRows);
  // },[flagauditRows])
  // console.log(auditDetails?.is_flagged,auditDetails);

  return (
    <div className="main-page h-100">
      {isRowClicked ? (
        <>
          {isDetailsLoading ? (
            <Spinner />
          ) : (
            <AuditDetails
              selectedIndex={selectedIndex}
              length={auditRows.length}
              auditDetails={auditDetails}
              handlePreviousClick={handlePreviousClick}
              handleNextClick={handleNextClick}
              setAuditDetails={setAuditDetails}
              failedAudits = {failedAudits}
              setFailedAudits = {setFailedAudits}
              getUpdatedAuditDetails={handleAuditDataUpdate}
              getAuditRowsData={getAuditRowsByFilter}
              setIsRowClicked={setIsRowClicked}
              priorityVal5={priorityVal5}
              flagauditRows={flagauditRows}
              editFlageData={editFlageData}
              setIsRowsLoading={setIsRowsLoading}
              setflagAuditRows={setflagAuditRows}
              selectedEpisodeRows={selectedEpisodeRows}
              isAllEpisodesSelected={isAllEpisodesSelected}
              setIsAllEpisodesSelected={setIsAllEpisodesSelected}
              setSelectedEpisodeRows={setSelectedEpisodeRows}
              recall_page={recall_page}
              setRecall_page={setRecall_page}
              isAssigned ={isAssigned}
              setIsAssigned={setIsAssigned}
              unassined_page={unassined_page}
              setUnassined_page ={setUnassined_page}
              addUnassignReason={addUnassignReason}
              setAddUnassignReason={setAddUnassignReason}
              appliedFilters={appliedFilters}
            />
          )}
        </>
      ) : (
        <div className="audit-content">
          <Navbar
           selectedColumns={selectedColumns}
            toggleColumnSelection={toggleColumnSelection}
            mode={mode}
            setMode={setMode}
            updatedAuditRows={updatedAuditRows}
            handleRefreshClick={handleRefreshClick}
            setAuditDetails={setAuditDetails}
            setIsRowsLoading={setIsRowsLoading}
            isRowsLoading={isRowsLoading}
            getAuditRowsByFilter={getAuditRowsByFilter}
            appliedFilters={appliedFilters}
            setAppliedFilters={setAppliedFilters}
            setHasMore={setHasMore}
            setPage={setPage}
            auditDetails={auditDetails}
            setAuditRows={setAuditRows}
            setflagAuditRows={setflagAuditRows}
            flagauditRows={flagauditRows}
            editFlageData={editFlageData}
            getAuditRowsData={getAuditRowsData}
            selectedEpisodeRows={selectedEpisodeRows}
            setSelectedEpisodeRows={setSelectedEpisodeRows}
            isAllEpisodesSelected={isAllEpisodesSelected}
            setIsAllEpisodesSelected={setIsAllEpisodesSelected}
            recall_page={recall_page}
            setRecall_page = {setRecall_page}
            isAssigned ={isAssigned}
            setIsAssigned={setIsAssigned}
            unassined_page={unassined_page}
            setUnassined_page ={setUnassined_page}
            addUnassignReason={addUnassignReason}
            setAddUnassignReason={setAddUnassignReason}
            searchEpisodeIdentifier={searchEpisodeIdentifier}
            setSearchEpisodeIdentifier={setSearchEpisodeIdentifier}
            recommendations={recommendations}
            setRecommendations={setRecommendations}
            selectAllFiles={selectAllFiles}
            setSelectAllFiles={setSelectAllFiles}          
             />

          <div className="audits w-100 h-100">
            <div
              className="side-navbar"
              style={{
                width: "20%",
                display: mode === "DARK" ? "block" : "none",
              }}
            >
              <SidenavbarTemp
                selectedColumns={selectedColumns}
            toggleColumnSelection={toggleColumnSelection}
            mode={mode}
            setMode={setMode}
            updatedAuditRows={updatedAuditRows}
            handleRefreshClick={handleRefreshClick}
            setAuditDetails={setAuditDetails}
            setIsRowsLoading={setIsRowsLoading}
            isRowsLoading={isRowsLoading}
            getAuditRowsByFilter={getAuditRowsByFilter}
            appliedFilters={appliedFilters}
            setAppliedFilters={setAppliedFilters}
            setHasMore={setHasMore}
            setPage={setPage}
            auditDetails={auditDetails}
            setAuditRows={setAuditRows}
            setflagAuditRows={setflagAuditRows}
            flagauditRows={flagauditRows}
            editFlageData={editFlageData}
            getAuditRowsData={getAuditRowsData}
            selectedEpisodeRows={selectedEpisodeRows}
            setSelectedEpisodeRows={setSelectedEpisodeRows}
            isAllEpisodesSelected={isAllEpisodesSelected}
            setIsAllEpisodesSelected={setIsAllEpisodesSelected}
            recall_page={recall_page}
            setRecall_page = {setRecall_page}
            isAssigned ={isAssigned}
            setIsAssigned={setIsAssigned}
            unassined_page={unassined_page}
            setUnassined_page ={setUnassined_page}
            addUnassignReason={addUnassignReason}
            setAddUnassignReason={setAddUnassignReason}
            searchEpisodeIdentifier={searchEpisodeIdentifier}
            setSearchEpisodeIdentifier={setSearchEpisodeIdentifier}
            recommendations={recommendations}
            setRecommendations={setRecommendations}
            selectAllFiles={selectAllFiles}
            setSelectAllFiles={setSelectAllFiles}
              />
            </div>
            <AuditRows
              selectedColumns={selectedColumns}
              shouldShowColumn = {shouldShowColumn}
              toggleColumnSelection={toggleColumnSelection}
             handleRowClick={handleRowClick}
              auditRows={auditRows}
              setAuditRows={setAuditRows}
              isRowsLoading={isRowsLoading}
              selectedIndex={selectedIndex}
              hasMore={hasMore}
              getAuditRowsByFilter={getAuditRowsByFilter}
              auditDetails={auditDetails}
              flagauditRows={flagauditRows}
              loadMore={() => getAuditRowsData({page:page})}
              seteditFlageData={seteditFlageData}
              getAuditRows={getAuditRows}
              getAuditDetailsById={getAuditDetailsById}
              setSelectedIndex={setSelectedIndex}
              setIsRowClicked={setIsRowClicked}
              setPriorityVal5={setPriorityVal5}
              selectedEpisodeRows={selectedEpisodeRows}
              setSelectedEpisodeRows={setSelectedEpisodeRows}
              isAllEpisodesSelected={isAllEpisodesSelected}
              setIsAllEpisodesSelected = {setIsAllEpisodesSelected}
              appliedFilters = {appliedFilters}
              setAppliedFilters = {setAppliedFilters}
              isAssigned ={isAssigned}
              setIsAssigned={setIsAssigned}
              unassined_page={unassined_page}
              setUnassined_page ={setUnassined_page}
            />
            {/* <div className="sidebar">
              <Sidebar
                updatedAuditRows={updatedAuditRows}
                setAuditDetails={setAuditDetails}
                getAuditRowsByFilter={getAuditRowsByFilter}
                handleP5PriorityClick={() => handleP5PriorityClick(1)}
              />
            </div> */}
          </div>
        </div>
      )}
    </div>
  );
}

export default Page;
